import React, { useEffect, useRef, useState } from 'react';
import request from '@/services/request.service';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from '@/stores/action/home.action';
import Package from './Package';
import Select from './SelectProduct';
import Total from './Total';
import { toFormData } from '@/utils/convert.util';
import { modalActions } from '@/stores/action/widget.action';
import ModalContainer from '@/containers/global/modal/ModalContainer';
import { getLocaleWordContent } from '@/utils/language.util';

const IntroModal = ({modal}) => {
  return(
    <div dangerouslySetInnerHTML={{__html: modal.content}} />
  )
}


function Balance({ user, UserActions, status, ModalActions }) {
    const input_addr = useRef();
    const user_id = user.getIn(['id']) || '';
    const total = user.getIn(['assets', 'POINT', 'total']);
    const total_2 = user.getIn(['child_total']);
    const link = user_id ? window.location.origin + '/#/signup?' + user_id : '';
    const [lst, setLst] = useState('');
    const [valueCoin, setValueCoin] = useState(0);
    const [show, setShow] = useState(false);

    
    const [modal, setModal] = useState([]);


    const handleOpenModal = (e) => {
        ModalActions.showModalEx({mode:2});
    }

    const _get_modal_notice = async () => {
        const param = { b_type : 'modal'};
        const rsp = await request.post('api/board/board_list.php', toFormData(param)).then(response => response.data)
        if (rsp.result < 0) {
            return rsp;
        } else {
            return rsp;
        }
    }


    
    const getList = async () => {
        const rsp = await request.post('/api/account/user_info.php').then((response) => response.data);

        if (rsp.result < 0) {
            window.alert(rsp.msg);
        } else {
            setLst(rsp.child_buy);
            return rsp;
        }
    };

    const fetchBusinesses = () => {
        ModalActions.showModalEx({mode:0});
        UserActions.getUserBalance();
        getList();
        _get_modal_notice().then((rsp)=>{
            if (rsp.list.length > 0)  {
                setModal(rsp.list[0]);
            }
        });
    };

    useEffect(fetchBusinesses, []);
    



    const handleCopy = (e) => {
        if (e) e.preventDefault();
        input_addr.current.select();
        document.execCommand('copy');
        alert('Copy success !');
    };

    //console.log("modal>>", modal);
    return (
        <>
            <div className="bg_balance_left">
                { modal.length !== 0 ? <ModalContainer id={modal.idx} width={'90%'} title={modal.title} body={<IntroModal modal={modal} />} timeLimit={true} /> : null }
                <p className="inner white">My account</p>
                <div className="sp10"></div>
                <div className="inner">
                    <div className="content_box">
                        <div className="box_coin">
                            <img src={require('@/resources/assets/images/ic_admin.png')} alt="admin" />
                        </div>
                        <div className="box_coin">
                            <p className="gray">{getLocaleWordContent('아이디')} </p>
                            <p className="gray">{getLocaleWordContent('이름')}</p>
                            <p className="gray">{getLocaleWordContent('센터')}</p>
                        </div>
                        <div className="box_coin">
                            <p className="black">{user_id}</p>
                            <p className="black">{user.getIn(['name']) || ''}</p>
                            <p className="black">{user.getIn(['center']) || ''}</p>
                        </div>
                        <input
                            type="text"
                            ref={input_addr}
                            defaultValue={link || ''}
                            style={{ opacity: '0', position: 'absolute', width: '100px' }}
                        />
                        <div className="box_coin">
                            <button className="b_orange btn01" onClick={(e) => handleCopy(e)}>
                                {getLocaleWordContent('추천ID복사')}
                            </button>
                        </div>
                    </div>
                    <div className="sp15"></div>

                    <div className="content_box">
                        <div className="box_coin">
                            <img src={require('@/resources/assets/images/ic_coin.png')} alt="coin" />
                        </div>
                        <div className="box_coin">
                            <div className="">
                                <p className="gray d_flex">
                                    <span>{getLocaleWordContent('잔고')}:</span>
                                    <span className="black">{user.getIn(['assets', 'POINT', 'total']) || ''} {getLocaleWordContent('원')}</span>
                                </p>
                                <p className="gray d_flex">
                                    <span>{getLocaleWordContent('사용가능')}:</span>
                                    <span className="black">{user.getIn(['assets', 'POINT', 'rest']) || ''} {getLocaleWordContent('원')}</span>
                                </p>
                                <p className="gray d_flex">
                                    <span>PS{getLocaleWordContent('수량')}:</span>
                                    <span className="black">{user.getIn(['assets', 'PS', 'total']) || ''} PS</span>
                                </p>
                                <p className="gray d_flex">
                                    <span>{getLocaleWordContent('알레오(Aleo)')}:</span>
                                    <span className="black">{user.getIn(['assets', 'PT', 'total']) || ''} PT</span>
                                </p>
                            </div>

                            <div className={`select_coin${show ? ' show' : ' hide'}`}>
                                {valueCoin > 0 ? (
                                    lst
                                        .filter((it) => it.no === valueCoin)
                                        .map((it, index) => (
                                            <div
                                                className="current_coin d_flex "
                                                onClick={() => setShow(!show)}
                                                key={index}
                                            >
                                                <div className="data_left">
                                                    <span>{getLocaleWordContent('알레오')}{it.no} {getLocaleWordContent('추천 갯수')}</span>
                                                </div>
                                                <div className="data_right">{it.total}개</div>
                                            </div>
                                        ))
                                ) : (
                                    <div className="current_coin d_flex " onClick={() => setShow(!show)}>
                                        <p className="gray">{getLocaleWordContent('추천판매수량')} :</p>
                                        <div className="gray">
                                            <span className="black">{total_2 || ''}</span>{getLocaleWordContent('개')}
                                        </div>
                                    </div>
                                )}

                                {show && (
                                    <Select
                                        lst={lst}
                                        valueCoin={valueCoin}
                                        setValueCoin={setValueCoin}
                                        setShow={setShow}
                                        total_2={total_2}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sp20"></div>
                <Total />
                <div className="sp20"></div>
                {total ? <Package total={total} /> : null}
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        user: state.home.getIn(['user']),
    }),
    (dispatch) => ({
        UserActions: bindActionCreators(userActions, dispatch),
        ModalActions: bindActionCreators(modalActions, dispatch)
    }),
)(Balance);
